module.exports = __webpack_public_path__ + "media/images/dmc/member-04-321851d5ddf9248c19b5b300d0c31ee3.jpg";